type Order = {
  order : number,
  productName: string
}

const array : Array<Order> =[
  {
    'order': 1,
    'productName': 'plannexo'
  },
  {
    'order': 2,
    'productName': 'bionexo'
  },
  {
    'order': 3,
    'productName': 'bionfe'
  },
  {
    'order': 4,
    'productName': 'opmenexo'
  },
  {
    'order': 5,
    'productName': 'biotracker'
  },
  {
    'order': 6,
    'productName': 'revolution'
  },
  {
    'order': 7,
    'productName': 'bioanalytics'
  },
  {
    'order': 8,
    'productName': 'avatar'
  },
  {
    'order': 9,
    'productName': 'biomanager'
  },
  {
    'order': 10,
    'productName': 'publinexo'
  }
];

export default array;